/**
 * Keyboard accessibility for mobile and desktop menu
 *
 * Space open/close hamburger or sub-menu
 */
const menuItems = document.querySelectorAll('.main-nav__desktop li>.menu-item-wrapper>button');
const firstLvlMenu = document.querySelectorAll('.main-nav__desktop ul>li:not(.menu-search-icon)');
// const subMenus = document.querySelectorAll(".sub-menu-wrapper, .menu-search-bar");

menuItems.forEach((menuItem) => {
  menuItem.addEventListener("keydown", handleMenuItemKeydown);
});

firstLvlMenu.forEach((firstLvl) => {
  firstLvl.addEventListener('focusout', (e) => openCloseSubMenu(e, firstLvl));
  firstLvl.addEventListener("mouseenter", (e) => openCloseSubMenu(e, firstLvl));
  firstLvl.addEventListener("mouseleave", (e) => openCloseSubMenu(e, firstLvl));
});

// subMenus.forEach((submenu) => {
//   submenu.addEventListener('focusout', (e) => { 
//     if (submenu.contains(e.relatedTarget)) return;

//     submenu.classList.remove("active");
//     const submenuTriggerBtn = document.querySelector(`[aria-controls="${submenu.id}"]`);
//     submenuTriggerBtn?.setAttribute('aria-expanded', 'false');
//     submenuTriggerBtn?.focus();
//   });
// });


function handleMenuItemKeydown(event) {
  if (event.key === " ") {
    event.preventDefault();
    const menuItem = event.target.closest('.menu-item');
    const submenu = menuItem.querySelector('.sub-menu-wrapper');
    if (submenu) {
      submenu.classList.toggle("active");
      event.target.ariaExpanded = event.target.ariaExpanded === 'true' ? 'false' : 'true';
    }  }
}

function openCloseSubMenu(event, firstLvl) {
  // console.log(event);
  // console.log(currentMenuItem);
  // if (currentMenuItem.contains(event.relatedTarget)) return;
  const submenu = firstLvl.querySelector('.sub-menu-wrapper');
  const submenuTriggerBtn = firstLvl.querySelector('button');

  if(event.type === 'focusout' || event.type === "mouseleave") {
    if (firstLvl.contains(event.relatedTarget)) return;

    submenu?.classList.remove("active");
    submenuTriggerBtn?.setAttribute('aria-expanded', 'false');
  } else if (event.type === 'mouseenter') {
    submenu?.classList.add("active");
    submenuTriggerBtn?.setAttribute('aria-expanded', 'true');
  }
}
